/**
 * Blog journal hub: tag pills, optional All grid, promo blocks (sliders/featured),
 * per-tag preloaded grids, pagination.
 */
(function () {
  var SLIDER_RETRY_MAX = 60;
  var bjhPopstateBound = false;
  var bjhWindowResizeBound = false;
  var bjhResizeDebounceTimer = null;

  function getHandle(btn) {
    return (btn.getAttribute('data-tag-handle') || 'all').toLowerCase();
  }

  function parseTags(attr) {
    return (attr || '')
      .split(',')
      .map(function (s) {
        return s.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function isTopicsLanding(h, split) {
    split = !!split;
    var x = (h || 'all').toLowerCase();
    return split ? x === 'topics' : x === 'all';
  }

  /** Hub landing where promo blocks are visible by default. */
  function isHubPromoLanding(h, split) {
    split = !!split;
    var x = (h || 'all').toLowerCase();
    if (split) return x === 'topics';
    return x === 'all';
  }

  function showsAllPostsGridMode(h, split) {
    split = !!split;
    var x = (h || '').toLowerCase();
    return split ? x === 'all-posts' : x === 'all';
  }

  function isTagArchiveLayout(h, split) {
    split = !!split;
    var x = (h || '').toLowerCase();
    if (!split) return x !== 'all';
    return x !== 'topics' && x !== 'all-posts';
  }

  function blockVisible(activeHandle, dataShowTags, split) {
    var tags = parseTags(dataShowTags);
    var ah = (activeHandle || '').toLowerCase();
    // Tabs semantics:
    // - If no tags set on the block, it shows only on hub landing (Topics).
    // - If tags are set, the block shows only when the active tab handle is included.
    // - Back-compat: treat "all" as "all-posts".
    if (tags.indexOf('all') !== -1 && tags.indexOf('all-posts') === -1) tags.push('all-posts');

    var onLandingHub = isHubPromoLanding(ah, split);
    if (tags.length === 0) return onLandingHub;
    return tags.indexOf(ah) !== -1;
  }

  function readBoolData(el, name) {
    if (!el) return false;
    var v = el.getAttribute('data-' + name) || '';
    return v === 'true' || v === '1';
  }

  /** Same math as sections/category-peek-slider.liquid (fractional slidesToShow). */
  function bjhSlidesToShowCount(sliderEl) {
    var w = window.innerWidth || document.documentElement.clientWidth;
    var mobileBp = parseInt(sliderEl.getAttribute('data-mobile-bp'), 10) || 600;
    var tabletBp = parseInt(sliderEl.getAttribute('data-tablet-bp'), 10) || 990;
    var slides;
    var peek;
    if (w <= mobileBp) {
      slides = parseFloat(sliderEl.getAttribute('data-slides-mobile')) || 1;
      peek = parseFloat(sliderEl.getAttribute('data-peek-mobile')) || 0;
    } else if (w <= tabletBp) {
      slides = parseFloat(sliderEl.getAttribute('data-slides-tablet')) || 3;
      peek = parseFloat(sliderEl.getAttribute('data-peek-tablet')) || 0;
    } else {
      slides = parseFloat(sliderEl.getAttribute('data-slides-desktop')) || 4;
      peek = parseFloat(sliderEl.getAttribute('data-peek-desktop')) || 0;
    }
    return slides + peek / 100;
  }

  /** Align slider track with the visible Bootstrap `container` that wraps the heading row. */
  function syncBjhPeekGutter(rootEl) {
    if (!rootEl || !rootEl.classList.contains('blog-journal-hub__peek--full-bleed')) return;

    var headerWrap = rootEl.querySelector('[data-bjh-peek-header-wrap]');
    var viewportEl = rootEl.querySelector('.blog-journal-hub__peek-viewport');
    if (!headerWrap || !viewportEl) return;

    var measureRect = headerWrap.getBoundingClientRect();
    var viewportRect = viewportEl.getBoundingClientRect();
    var padLeft = parseFloat(window.getComputedStyle(headerWrap).paddingLeft) || 0;

    var contentLeft = measureRect.left + padLeft - viewportRect.left;
    if (isNaN(contentLeft)) return;

    rootEl.style.setProperty('--bjh-content-left', contentLeft + 'px');
  }

  function bindBjhSliderArrows($el, el, bid, getSlidesToShow) {
    var $ = window.jQuery;
    if (!$) return;

    function updateSliderArrows() {
      var autoHide = el.getAttribute('data-bjh-auto-hide-arrows');
      var cardCount =
        parseInt(el.getAttribute('data-bjh-card-count'), 10) ||
        el.querySelectorAll('.blog-journal-hub__cell').length ||
        el.children.length ||
        0;

      var slidesToShow = typeof getSlidesToShow === 'function' ? getSlidesToShow() : 4;
      try {
        var opt = $el.slick('slickGetOption', 'slidesToShow');
        if (typeof opt === 'number') slidesToShow = opt;
      } catch (e) {}

      var canScroll = cardCount > slidesToShow + 1e-6;
      var $prev = $('[data-bjh-prev="' + bid + '"]');
      var $next = $('[data-bjh-next="' + bid + '"]');

      if (autoHide !== 'false') {
        $prev.css('display', canScroll ? '' : 'none');
        $next.css('display', canScroll ? '' : 'none');
      }

      try {
        var slick = $el.slick('getSlick');
        var current = slick && typeof slick.currentSlide === 'number' ? slick.currentSlide : 0;
        var slideCount = slick && typeof slick.slideCount === 'number' ? slick.slideCount : cardCount;
        var prevDisabled = !canScroll || current <= 0;
        var nextDisabled = !canScroll || current >= Math.max(0, slideCount - slidesToShow);

        $prev.prop('disabled', prevDisabled).attr('aria-disabled', prevDisabled ? 'true' : 'false');
        $next.prop('disabled', nextDisabled).attr('aria-disabled', nextDisabled ? 'true' : 'false');
      } catch (e) {}
    }

    updateSliderArrows();
    $el.off('.bjhArrows').on('afterChange.bjhArrows reInit.bjhArrows setPosition.bjhArrows', updateSliderArrows);

    $('[data-bjh-prev="' + bid + '"]')
      .off('click.bjh')
      .on('click.bjh', function (e) {
        e.preventDefault();
        $el.slick('slickPrev');
      });
    $('[data-bjh-next="' + bid + '"]')
      .off('click.bjh')
      .on('click.bjh', function (e) {
        e.preventDefault();
        $el.slick('slickNext');
      });

    return updateSliderArrows;
  }

  function initBjhPeekSlider(el) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;
    if (!el) return;
    if (!el.children.length) return;
    var $el = $(el);
    if ($el.hasClass('slick-initialized')) return;

    var root = el.closest('.blog-journal-hub__peek--full-bleed');
    if (root) syncBjhPeekGutter(root);

    var id = el.id || '';
    var bid = id.replace('blog-journal-hub-slider-', '');

    var cardCount = el.querySelectorAll('.blog-journal-hub__cell').length || el.children.length || 0;
    el.setAttribute('data-bjh-card-count', String(cardCount));
    el.setAttribute('data-bjh-slider-bid', bid);

    var slidesToShow = bjhSlidesToShowCount(el);

    $el.slick({
      dots: false,
      infinite: false,
      arrows: false,
      adaptiveHeight: false,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      swipe: true,
      touchMove: true,
    });

    bindBjhSliderArrows($el, el, bid, function () {
      return bjhSlidesToShowCount(el);
    });

    window.setTimeout(function () {
      equalizeSliderCardHeights(el);
      if (root) syncBjhPeekGutter(root);
      try {
        $el.slick('setPosition');
      } catch (e) {}
    }, 0);
  }

  function reinitBjhPeekSlider(sliderEl) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick || !sliderEl) return;
    if (!readBoolData(sliderEl, 'bjh-peek-mode')) return;

    var $el = $(sliderEl);
    var root = sliderEl.closest('.blog-journal-hub__peek--full-bleed');
    if (root) syncBjhPeekGutter(root);

    if ($el.hasClass('slick-initialized')) {
      try {
        $el.slick('unslick');
      } catch (e) {}
    }

    initBjhPeekSlider(sliderEl);
  }

  function blogJournalHubInitSliders(root, retryCount) {
    retryCount = retryCount || 0;
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) {
      if (retryCount < SLIDER_RETRY_MAX) {
        setTimeout(function () {
          blogJournalHubInitSliders(root, retryCount + 1);
        }, 50);
      }
      return;
    }

    root.querySelectorAll('[data-bjh-slick].blog-journal-hub__track--slider').forEach(function (el) {
      if (!el.children.length) return;
      var $el = $(el);
      if ($el.hasClass('slick-initialized')) return;

      if (readBoolData(el, 'bjh-peek-mode')) {
        initBjhPeekSlider(el);
        return;
      }

      var desktop = parseInt(el.getAttribute('data-slides-desktop'), 10) || 4;
      var id = el.id || '';
      var bid = id.replace('blog-journal-hub-slider-', '');

      var cardCount = el.querySelectorAll('.blog-journal-hub__cell').length || el.children.length || 0;
      el.setAttribute('data-bjh-card-count', String(cardCount));
      el.setAttribute('data-bjh-slider-bid', bid);

      $el.slick({
        dots: false,
        infinite: false,
        arrows: false,
        adaptiveHeight: false,
        swipe: true,
        touchMove: true,
        draggable: true,
        slidesToShow: desktop,
        slidesToScroll: 1,
        responsive: [
          { breakpoint: 1100, settings: { slidesToShow: Math.min(3, desktop) } },
          { breakpoint: 750, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } },
        ],
      });

      bindBjhSliderArrows($el, el, bid, function () {
        return desktop;
      });

      window.setTimeout(function () {
        equalizeSliderCardHeights(el);
      }, 0);
    });
  }

  function blogJournalHubDestroySlidersForTagView(root) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;

    function clearEqualizedCards(sliderEl) {
      if (!sliderEl) return;
      sliderEl.querySelectorAll('.bjh-hub-article-card, .bjh-hub-video-card').forEach(function (card) {
        card.style.height = '';
      });
      sliderEl.style.removeProperty('--bjh-card-radius');
    }

    root.querySelectorAll('[data-bjh-slick].blog-journal-hub__track--slider').forEach(function (el) {
      var $el = $(el);
      if ($el.hasClass('slick-initialized')) {
        var id = el.id || '';
        var bid = id.replace('blog-journal-hub-slider-', '');
        $('[data-bjh-prev="' + bid + '"], [data-bjh-next="' + bid + '"]').off('click.bjh');
        $el.slick('unslick');
      }
      clearEqualizedCards(el);
      el.classList.add('bjh-track-tagged-grid');
    });
  }

  function blogJournalHubPrepareAllView(root) {
    root.querySelectorAll('.bjh-track-tagged-grid').forEach(function (el) {
      el.classList.remove('bjh-track-tagged-grid');
    });
  }

  function equalizeSliderCardHeights(sliderEl) {
    if (!sliderEl) return;
    var hubRoot = sliderEl.closest('[data-blog-journal-hub]');
    if (hubRoot) {
      var eqEnabled = hubRoot.getAttribute('data-bjh-enable-equalize-heights');
      if (eqEnabled === 'false') return;
    }
    var cards = sliderEl.querySelectorAll('.bjh-hub-article-card, .bjh-hub-video-card');
    if (!cards || !cards.length) return;

    var maxH = 0;
    cards.forEach(function (c) {
      // reset first so we measure natural height for the current responsive state
      c.style.height = '';
      c.style.borderRadius = '';
      var h = c.getBoundingClientRect().height;
      if (h > maxH) maxH = h;
    });

    // Optional dynamic radius based on measured height
    // (radius style is controlled in the section customizer)
    var radiusMode = hubRoot ? hubRoot.getAttribute('data-bjh-card-radius-mode') : 'dynamic';
    radiusMode = radiusMode || 'dynamic';
    var radius = null;
    if (radiusMode === 'dynamic') {
      var dynMin = parseInt((hubRoot && hubRoot.getAttribute('data-bjh-card-radius-dynamic-min-px')) || '12', 10);
      var dynMax = parseInt((hubRoot && hubRoot.getAttribute('data-bjh-card-radius-dynamic-max-px')) || '20', 10);
      var dynMulThousandths = parseFloat((hubRoot && hubRoot.getAttribute('data-bjh-card-radius-dynamic-multiplier-thousandths')) || '55');
      var dynMul = dynMulThousandths / 1000;
      radius = Math.round(Math.max(dynMin, Math.min(dynMax, maxH * dynMul)));
    }

    cards.forEach(function (c) {
      c.style.height = maxH + 'px';
    });

    // Drive card rounding via CSS variable for consistency.
    if (radiusMode === 'dynamic' && radius !== null) {
      sliderEl.style.setProperty('--bjh-card-radius', radius + 'px');
    }
  }

  function normalizeVideoUrl(url) {
    if (!url) return '';
    var u = String(url).trim();
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (!/^https?:\/\//i.test(u)) return 'https://' + u;
    return u;
  }

  function youtubeVideoId(url) {
    if (!url) return '';
    var u = String(url);
    var m = u.match(/[?&]v=([\w-]{11})/);
    if (m) return m[1];
    m = u.match(/youtu\.be\/([\w-]{11})/);
    if (m) return m[1];
    m = u.match(/youtube\.com\/embed\/([\w-]{11})/);
    if (m) return m[1];
    m = u.match(/youtube\.com\/shorts\/([\w-]{11})/);
    return m ? m[1] : '';
  }

  function vimeoVideoId(url) {
    if (!url) return '';
    var m = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : '';
  }

  function videoEmbedSrc(url) {
    if (!url) return '';
    var y = youtubeVideoId(url);
    if (y) {
      return 'https://www.youtube.com/embed/' + y + '?autoplay=1&rel=0&playsinline=1';
    }
    var v = vimeoVideoId(url);
    if (v) {
      return 'https://player.vimeo.com/video/' + v + '?autoplay=1';
    }
    return '';
  }

  function isLikelyDirectVideoFile(url) {
    return /\.(mp4|webm|ogg)(\?|#|$)/i.test(String(url));
  }

  function initVideoModal(root) {
    var modal = root.querySelector('[data-bjh-video-modal]');
    var frame = root.querySelector('[data-bjh-video-modal-frame]');
    var titleEl = modal ? modal.querySelector('[data-bjh-video-dialog-title]') : null;
    var closeBtn = modal ? modal.querySelector('.blog-journal-hub__video-modal__close') : null;
    if (!modal || !frame) return;

    var lastFocused = null;
    var onDocKey = function (e) {
      if (e.key === 'Escape') closeModal();
    };

    function clearVideoFrame() {
      var v = frame.querySelector('video');
      if (v) {
        try {
          v.pause();
          v.removeAttribute('src');
          v.load();
        } catch (err) {}
      }
      frame.querySelectorAll('iframe').forEach(function (ifr) {
        try {
          ifr.setAttribute('src', 'about:blank');
        } catch (e) {}
      });
      frame.innerHTML = '';
    }

    function closeModal() {
      clearVideoFrame();
      modal.hidden = true;
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bjh-video-modal-open');
      document.removeEventListener('keydown', onDocKey);
      if (titleEl) {
        var defTitle = titleEl.getAttribute('data-bjh-default-title');
        if (defTitle) titleEl.textContent = defTitle;
      }
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try {
          lastFocused.focus();
        } catch (err) {}
      }
      lastFocused = null;
    }

    function openModal(rawUrl, videoTitle) {
      clearVideoFrame();
      var url = normalizeVideoUrl(rawUrl);
      if (!url) return;

      var titleText = (videoTitle || '').trim() || (titleEl && titleEl.getAttribute('data-bjh-default-title')) || 'Video';
      if (titleEl) {
        titleEl.textContent = titleText;
      }

      var embedSrc = videoEmbedSrc(url);

      if (embedSrc) {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', embedSrc);
        iframe.setAttribute('title', titleText);
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
        );
        frame.appendChild(iframe);
      } else if (isLikelyDirectVideoFile(url)) {
        var video = document.createElement('video');
        video.setAttribute('src', url);
        video.setAttribute('controls', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('title', titleText);
        video.autoplay = true;
        frame.appendChild(video);
      } else {
        var fallbackIframe = document.createElement('iframe');
        fallbackIframe.setAttribute('src', url);
        fallbackIframe.setAttribute('title', titleText);
        fallbackIframe.setAttribute('allowfullscreen', '');
        frame.appendChild(fallbackIframe);
      }

      lastFocused = document.activeElement;
      modal.hidden = false;
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bjh-video-modal-open');
      document.addEventListener('keydown', onDocKey);
      window.requestAnimationFrame(function () {
        if (closeBtn && typeof closeBtn.focus === 'function') {
          closeBtn.focus();
        }
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bjh-video-open]');
      if (!t || !root.contains(t)) return;
      e.preventDefault();
      var url = t.getAttribute('data-bjh-video-url');
      if (!url) return;
      var vtitle = t.getAttribute('data-bjh-video-title');
      openModal(url, vtitle);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      var opener = t.closest('[data-bjh-video-open]');
      if (!opener || !root.contains(opener)) return;
      if (!opener.hasAttribute('tabindex')) return;
      e.preventDefault();
      if (e.key === ' ') e.stopPropagation();
      var url = opener.getAttribute('data-bjh-video-url');
      var vtitle = opener.getAttribute('data-bjh-video-title');
      if (url) openModal(url, vtitle);
    });

    modal.querySelectorAll('[data-bjh-video-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    });
  }

  function applyFilter(root, activeHandle) {
    var h = (activeHandle || 'all').toLowerCase();
    root.setAttribute('data-bjh-client-filter', h);
    var split = readBoolData(root, 'bjh-topics-posts-split');
    var hidePromosOnTag = readBoolData(root, 'bjh-hide-promos-on-tag');
    var showAllGridSetting = readBoolData(root, 'bjh-show-all-grid');
    var allGridEl = root.querySelector('[data-bjh-all-grid]');
    var archiveLayout = isTagArchiveLayout(h, split);
    var showsAllTab = showAllGridSetting && showsAllPostsGridMode(h, split);

    var tagLinks = root.querySelectorAll('[data-bjh-tag-link]');
    tagLinks.forEach(function (btn) {
      var on = getHandle(btn) === h;
      btn.classList.toggle('bjh-tag--active', on);
      if (on) {
        btn.setAttribute('aria-current', 'page');
      } else {
        btn.removeAttribute('aria-current');
      }
    });

    if (allGridEl) {
      allGridEl.hidden = !showsAllTab;
      allGridEl.setAttribute('aria-hidden', showsAllTab ? 'false' : 'true');
    }

    root.querySelectorAll('[data-bjh-tag-grid-panel]').forEach(function (panel) {
      var ph = (panel.getAttribute('data-tag-handle') || '').toLowerCase();
      var showPanel = archiveLayout && ph === h;
      panel.hidden = !showPanel;
      panel.setAttribute('aria-hidden', showPanel ? 'false' : 'true');
    });

    // Client-side pagination for All tab only (preloaded grid).
    // Note: can only paginate the items that exist in the DOM (Shopify caps blog pages at 50).
    (function syncAllTabPagination() {
      if (!split || !showAllGridSetting) return;
      if (!allGridEl) return;
      var track = allGridEl.querySelector('[data-bjh-all-grid-track]');
      var pager = allGridEl.querySelector('[data-bjh-all-grid-pagination]');
      if (!track || !pager) return;

      var items = Array.prototype.slice.call(track.querySelectorAll('.blog-journal-hub__cell'));
      var perPage = parseInt(root.getAttribute('data-bjh-all-tab-page-size') || '12', 10);
      if (!perPage || perPage < 1) perPage = 12;

      var total = items.length;
      var pages = Math.max(1, Math.ceil(total / perPage));
      var current = parseInt(pager.getAttribute('data-page') || '1', 10);
      if (!current || current < 1) current = 1;
      if (current > pages) current = pages;

      if (!showsAllTab) {
        pager.hidden = true;
        pager.setAttribute('aria-hidden', 'true');
        pager.setAttribute('data-page', '1');
        // Ensure everything is visible when not on All tab to avoid odd focus states.
        items.forEach(function (li) {
          li.hidden = false;
          li.removeAttribute('aria-hidden');
        });
        return;
      }

      // Render the current page.
      var start = (current - 1) * perPage;
      var end = start + perPage;
      items.forEach(function (li, idx) {
        var on = idx >= start && idx < end;
        li.hidden = !on;
        li.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      // Pager UI.
      pager.hidden = pages <= 1;
      pager.setAttribute('aria-hidden', pages <= 1 ? 'true' : 'false');
      pager.setAttribute('data-page', String(current));
      if (pages <= 1) {
        pager.innerHTML = '';
        return;
      }

      var html = '';
      html += '<nav class="pagination" role="navigation" aria-label="Pagination">';
      html += '<ul class="pagination__list list-unstyled" role="list">';
      html +=
        '<li><button type="button" class="pagination__item pagination__item--prev" data-bjh-all-page="prev" ' +
        (current <= 1 ? 'disabled aria-disabled="true"' : '') +
        '>Previous</button></li>';

      // Keep it simple: show up to 7 page buttons.
      var windowSize = 7;
      var half = Math.floor(windowSize / 2);
      var from = Math.max(1, current - half);
      var to = Math.min(pages, from + windowSize - 1);
      from = Math.max(1, to - windowSize + 1);

      if (from > 1) {
        html += '<li><button type="button" class="pagination__item" data-bjh-all-page="1">1</button></li>';
        if (from > 2) html += '<li><span class="pagination__item" aria-hidden="true">…</span></li>';
      }

      for (var p = from; p <= to; p++) {
        var isCur = p === current;
        html +=
          '<li><button type="button" class="pagination__item' +
          (isCur ? ' pagination__item--current' : '') +
          '" data-bjh-all-page="' +
          p +
          '" ' +
          (isCur ? 'aria-current="page"' : '') +
          '>' +
          p +
          '</button></li>';
      }

      if (to < pages) {
        if (to < pages - 1) html += '<li><span class="pagination__item" aria-hidden="true">…</span></li>';
        html +=
          '<li><button type="button" class="pagination__item" data-bjh-all-page="' +
          pages +
          '">' +
          pages +
          '</button></li>';
      }

      html +=
        '<li><button type="button" class="pagination__item pagination__item--next" data-bjh-all-page="next" ' +
        (current >= pages ? 'disabled aria-disabled="true"' : '') +
        '>Next</button></li>';
      html += '</ul></nav>';
      pager.innerHTML = html;

      if (!pager.__bjhBound) {
        pager.__bjhBound = true;
        pager.addEventListener('click', function (e) {
          var btn = e.target && e.target.closest ? e.target.closest('button[data-bjh-all-page]') : null;
          if (!btn || !pager.contains(btn)) return;
          if (btn.disabled) return;
          e.preventDefault();
          var v = btn.getAttribute('data-bjh-all-page');
          var nextPage = current;
          if (v === 'prev') nextPage = Math.max(1, current - 1);
          else if (v === 'next') nextPage = Math.min(pages, current + 1);
          else nextPage = parseInt(v || '1', 10) || 1;
          pager.setAttribute('data-page', String(nextPage));
          // Re-run with the updated page.
          applyFilter(root, h);
          try {
            // allGridEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            var gridRect = allGridEl.getBoundingClientRect();
            var headerHeight = 150;
            var targetPosition = window.pageYOffset + gridRect.top - headerHeight;
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          } catch (eScroll) {}
        });
      }
    })();

    root.querySelectorAll('[data-bjh-promo-block]').forEach(function (block) {
      var showTags = block.getAttribute('data-block-show-tags') || '';
      var show;
      if (hidePromosOnTag && !isHubPromoLanding(h, split)) {
        show = false;
      } else {
        show = blockVisible(h, showTags, split);
      }
      block.hidden = !show;
      block.setAttribute('aria-hidden', show ? 'false' : 'true');
    });

    document.documentElement.classList.toggle('bjh-tag-filter-active', archiveLayout);
    root.classList.toggle('bjh--tag-view', archiveLayout);

    var pag = root.querySelector('[data-bjh-pagination]');
    if (pag) {
      var pagHidden = isTopicsLanding(h, split);
      pag.hidden = pagHidden;
      pag.setAttribute('aria-hidden', pagHidden ? 'true' : 'false');
    }

    if (!archiveLayout) {
      blogJournalHubPrepareAllView(root);
      blogJournalHubInitSliders(root);
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        window.jQuery(root).find('.bjh-slider.slick-initialized').each(function () {
          window.jQuery(this).slick('setPosition');
        });
      }
    } else if (hidePromosOnTag) {
      blogJournalHubPrepareAllView(root);
    } else {
      blogJournalHubDestroySlidersForTagView(root);
    }

    document.querySelectorAll('[data-bjh-hide-when-tagged="true"]').forEach(function (marker) {
      var section = marker.closest('[id^="shopify-section-"]');
      if (!section) return;
      section.hidden = archiveLayout;
      section.setAttribute('aria-hidden', archiveLayout ? 'true' : 'false');
    });

    window.dispatchEvent(
      new CustomEvent('blogJournalHub:change', {
        detail: { handle: h, hidePromosOnTag: hidePromosOnTag },
      })
    );
  }

  function bindBjhWindowResizeOnce() {
    if (bjhWindowResizeBound) return;
    bjhWindowResizeBound = true;
    window.addEventListener('resize', function () {
      if (bjhResizeDebounceTimer) window.clearTimeout(bjhResizeDebounceTimer);
      bjhResizeDebounceTimer = window.setTimeout(function () {
        var $ = window.jQuery;
        document.querySelectorAll('[data-blog-journal-hub]').forEach(function (hubRoot) {
          if (!hubRoot || !hubRoot.isConnected) return;
          hubRoot.querySelectorAll('[data-bjh-peek-mode="true"]').forEach(function (slider) {
            reinitBjhPeekSlider(slider);
          });

          hubRoot.querySelectorAll('[data-bjh-slick].blog-journal-hub__track--slider').forEach(function (slider) {
            equalizeSliderCardHeights(slider);

            var bid = slider.getAttribute('data-bjh-slider-bid') || '';
            var autoHide = slider.getAttribute('data-bjh-auto-hide-arrows');
            if (autoHide === 'false') return;
            var cardCount = parseInt(slider.getAttribute('data-bjh-card-count') || '0', 10);
            var slidesToShow = parseInt(slider.getAttribute('data-slides-desktop'), 10) || 4;
            if ($ && $(slider).hasClass('slick-initialized')) {
              try {
                var opt = $(slider).slick('slickGetOption', 'slidesToShow');
                if (typeof opt === 'number') slidesToShow = opt;
              } catch (e) {}
            }

            if (bid) {
              var canScroll = cardCount > slidesToShow + 1e-6;
              hubRoot
                .querySelectorAll('[data-bjh-prev="' + bid + '"], [data-bjh-next="' + bid + '"]')
                .forEach(function (arrowBtn) {
                  arrowBtn.style.display = canScroll ? '' : 'none';
                });
            }

            if ($ && $(slider).hasClass('slick-initialized') && !readBoolData(slider, 'bjh-peek-mode')) {
              try {
                $(slider).slick('setPosition');
              } catch (e) {}
            }
          });
        });
      }, 200);
    });
  }

  function initRoot(root, replayFilterHandle) {
    initVideoModal(root);
    bindBjhWindowResizeOnce();

    function fetchAndReplace(url, replayAfterFilter) {
      if (!url) return;
      if (root.getAttribute('data-bjh-ajax-busy') === 'true') return;

      var cleanUrl = String(url).split('#')[0];
      if (!cleanUrl) return;

      // Preserve current template view (e.g. ?view=updated) so the fetched page
      // contains the same section markup and we can swap it in-place.
      try {
        var current = new URL(window.location.href);
        var view = current.searchParams.get('view');
        if (view) {
          var target = new URL(cleanUrl, window.location.origin);
          if (!target.searchParams.get('view')) {
            target.searchParams.set('view', view);
            cleanUrl = target.toString();
          }
        }
      } catch (e) {}

      root.setAttribute('data-bjh-ajax-busy', 'true');
      root.setAttribute('aria-busy', 'true');

      fetch(cleanUrl, {
        method: 'GET',
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextRoot = doc.getElementById(root.id);
          if (!nextRoot) {
            // Fallback to full navigation if we can't find the section.
            window.location.href = cleanUrl;
            return;
          }

          nextRoot.removeAttribute('aria-busy');
          nextRoot.removeAttribute('data-bjh-ajax-busy');

          root.replaceWith(nextRoot);
          initRoot(nextRoot, replayAfterFilter);

          try {
            if (replayAfterFilter === 'all-posts' && history && history.pushState) {
              var ux = new URL(cleanUrl, window.location.href);
              history.pushState({}, '', ux.pathname + ux.search + '#all-posts');
            } else if (replayAfterFilter !== 'all-posts' && history && history.replaceState) {
              var hh0 = (window.location.hash || '').replace(/^#\/?/, '').toLowerCase();
              if (hh0 === 'all-posts') {
                var u0 = new URL(window.location.href);
                history.replaceState({}, '', u0.pathname + u0.search);
              }
            }
          } catch (eHist) {}

          // Optional: keep the viewport stable by scrolling to the section top.
          // Comment out if you don't want auto-scroll on tag/pagination click.
          try {
            nextRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } catch (e) {}
        })
        .catch(function () {
          // If fetch fails, do normal navigation.
          window.location.href = cleanUrl;
        });
    }

    // Tag pills + pagination: delegated click handler
    root.addEventListener('click', function (e) {
      if (!e || e.defaultPrevented) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (typeof e.button === 'number' && e.button !== 0) return;

      var tagLink = e.target && e.target.closest ? e.target.closest('[data-bjh-tag-link]') : null;
      if (tagLink && root.contains(tagLink)) {
        e.preventDefault();
        var splitNow = readBoolData(root, 'bjh-topics-posts-split');
        var hNow = getHandle(tagLink);
        // Client-side tab switch (all grids are pre-rendered/hidden).
        // IMPORTANT: do NOT call history.pushState/replaceState here because
        // other theme scripts hook those and may re-initialize footer embeds (e.g. Klaviyo).
        if (!splitNow && hNow === 'topics') hNow = 'all';

        applyFilter(root, hNow);
        return;
      }

      var pagWrap = e.target && e.target.closest ? e.target.closest('[data-bjh-pagination]') : null;
      if (pagWrap && root.contains(pagWrap)) {
        var a = e.target.closest('a[href]');
        if (!a) return;
        e.preventDefault();
        var replayPag = undefined;
        if (readBoolData(root, 'bjh-topics-posts-split')) {
          var cf = (root.getAttribute('data-bjh-client-filter') || '').toLowerCase();
          if (cf === 'all-posts') replayPag = 'all-posts';
        }
        fetchAndReplace(a.getAttribute('href'), replayPag);
      }
    });

    var splitOn = readBoolData(root, 'bjh-topics-posts-split');
    var initial = (root.getAttribute('data-bjh-initial-tag') || 'all').toLowerCase();
    if (replayFilterHandle === 'all-posts') {
      initial = 'all-posts';
    } else if (splitOn) {
      try {
        var rawHash = window.location.hash || '';
        var hashKey = rawHash.replace(/^#\/?/, '').toLowerCase();
        if (hashKey) initial = hashKey;
      } catch (e1) {}
    }
    applyFilter(root, initial);
  }

  function init() {
    if (!bjhPopstateBound) {
      bjhPopstateBound = true;
      // No URL-driven navigation for tabs.
    }
    document.querySelectorAll('[data-blog-journal-hub]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
